import type { SVGProps } from "react";
import React from "react";
export function GallerySVG(props: SVGProps<SVGSVGElement>) {
  return (
   <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={29}
    fill="none"
    {...props}
  >
    <path
      fill="#624963"
      d="M21.902 4.634a3.805 3.805 0 0 1 3.805 3.805v13.464a3.805 3.805 0 0 1-3.805 3.804H8.44a3.805 3.805 0 0 1-3.805-3.804v-7.315c.555.231 1.144.399 1.756.493v6.822c0 .244.043.478.121.695l6.817-6.674c.975-.955 2.507-1 3.535-.137l.15.137 6.817 6.675c.078-.218.121-.452.121-.696V8.439a2.049 2.049 0 0 0-2.049-2.049h-6.82a7.553 7.553 0 0 0-.495-1.756h7.315Zm-7.248 12.462-.098.082-6.798 6.657c.213.075.442.116.681.116h13.463c.239 0 .467-.04.68-.115l-6.797-6.658a.878.878 0 0 0-1.13-.082Zm4.324-8.364a2.637 2.637 0 1 1 0 5.273 2.637 2.637 0 0 1 0-5.273ZM7.561 1.122a6.44 6.44 0 1 1 0 12.878 6.44 6.44 0 0 1 0-12.878Zm11.417 9.366a.88.88 0 1 0 0 1.76.88.88 0 0 0 0-1.76ZM7.561 3.463l-.105.01a.586.586 0 0 0-.471.47l-.01.105v2.927H4.046l-.105.01a.586.586 0 0 0-.47.47l-.01.106.01.105a.586.586 0 0 0 .47.471l.105.01 2.93-.001v2.931l.01.106a.586.586 0 0 0 .471.47l.105.01.105-.01a.586.586 0 0 0 .471-.47l.01-.106V8.146h2.93l.106-.009a.586.586 0 0 0 .47-.47l.01-.106-.01-.105a.586.586 0 0 0-.47-.47l-.105-.01-2.933-.001V4.048l-.01-.105a.586.586 0 0 0-.47-.47l-.105-.01Z"
    />
  </svg>
  );
}
